const PARTNER_1 = "https://customer-assets.emergentagent.com/job_lexsant-legal/artifacts/ggpq1vgl_WhatsApp%20Image%202026-02-19%20at%2017.13.53.jpeg";
const PARTNER_2 = "/garvil.jpg";

const partners = [
{
  name: "Samarth Singh Dhumal",
  title: "Founding Partner | Sports Law, Governance & Strategic Advisory",
  photo: PARTNER_1,
  linkedin: "https://linkedin.com/in/samarth-singh-dhumal-629b31201",
  bio: "Samarth Singh Dhumal is a sports business and legal professional with experience spanning sports governance, commercial strategy, taxation litigation, athlete advisory, and institutional development. He is currently pursuing a Master's in Sports Management & Legal Skills with the Barça Innovation Hub at ISDE, Barcelona.",
  bio2: "His professional experience bridges the legal and commercial dimensions of sport, having worked with leading stakeholders across the Indian sports ecosystem, including the Gujarat Titans, Himachal Pradesh Cricket Association, Minerva Academy FC, the Board of Control for Cricket in India (BCCI), and Vaish Associates. Samarth advises athletes, sports organizations, clubs, federations, startups, and commercial stakeholders on sports governance, sponsorship structures, commercial rights, athlete representation, dispute resolution, and regulatory compliance.",
  areas: ["Sports Law & Governance", "Athlete Representation", "Sports Commercial Strategy", "Sponsorship & Commercial Rights", "Sports Arbitration & Dispute Resolution", "Taxation & Regulatory Advisory", "Contract Structuring & Negotiation"],
  highlights: [
  "Master's Candidate, Sports Management & Legal Skills, ISDE Barcelona & Barça Innovation Hub",
  "Former Associate, Vaish Associates Advocates",
  "Commercial & Finance Intern, Gujarat Titans (IPL)",
  "Legal & Management Consultant, Himachal Pradesh Cricket Association",
  "Legal Advisor, Minerva Academy FC",
  "Former Legal Intern, BCCI",
  "FIFA Football Agent"]

},
{
  name: "Garvil Singh",
  title: "Founding Partner | Disputes, Litigation, Regulatory & White-Collar Defence",
  photo: PARTNER_2,
  linkedin: "https://linkedin.com/in/garvil",
  bio: "Garvil Singh is an advocate practicing before the Supreme Court of India, Delhi High Court, tribunals, and courts across India. He serves as designated counsel for the Union of India and has extensive experience in constitutional, commercial, criminal, regulatory, banking, insolvency, and white-collar litigation.",
  bio2: "Prior to founding LexSant Legal & Advisory LLP, Garvil worked with leading litigation chambers, He has represented clients in complex matters involving the Prevention of Money Laundering Act (PMLA), Prevention of Corruption Act, banking recovery proceedings, insolvency disputes, constitutional matters and commercial arbitration. His experience includes appearances before the Supreme Court of India, Delhi High Court, Gujarat High Court, Punjab & Haryana High Court, DRT, DRAT, NCLT, NCLAT, and other judicial and quasi-judicial forums.",
  areas: ["Supreme Court Litigation", "Constitutional & Administrative Law", "White-Collar Crime Defence", "Banking & Financial Litigation", "Insolvency & Bankruptcy", "Commercial Litigation", "Arbitration", "Regulatory & Enforcement Proceedings"],
  highlights: []
}];


const LinkedInIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#0A66C2">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const PartnerCard = ({ partner, index }) => (
  <div
    data-testid={`partner-card-${index}`}
    className="animate-on-scroll group border border-gold/20 bg-navy-dark overflow-hidden hover:border-gold/40 transition-all duration-500">

    <div className="aspect-[4/3] overflow-hidden relative">
      <div className="absolute inset-0 bg-navy-dark/20 z-10" />
      <img
        src={partner.photo}
        alt={partner.name}
        className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-700" />
    </div>
    <div className="p-8 md:p-10 space-y-4">
      <div>
        <h3 className="font-heading text-2xl md:text-3xl text-white tracking-tight">
          {partner.name}
        </h3>
        <div className="flex items-center gap-3 mt-1">
          <p className="text-sm tracking-widest uppercase text-gold/70 font-body">
            {partner.title}
          </p>
          <a
            href={partner.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`partner-linkedin-${index}`}
            className="hover:opacity-80 transition-opacity">
            <LinkedInIcon />
          </a>
        </div>
      </div>
      <p className="text-sm md:text-base text-gray-400 font-body leading-relaxed">
        {partner.bio}
      </p>
      {partner.bio2 &&
        <p className="text-sm md:text-base text-gray-400 font-body leading-relaxed">
          {partner.bio2}
        </p>
      }

      <div className="pt-2">
        <p className="text-xs tracking-widest uppercase text-gold/50 font-body mb-3">Areas of Practice</p>
        <div className="flex flex-wrap gap-2">
          {partner.areas.map((area) =>
            <span
              key={area}
              className="text-xs font-body tracking-wide text-gold/80 border border-gold/20 px-3 py-1">
              {area}
            </span>
          )}
        </div>
      </div>

      {partner.highlights.length > 0 &&
        <div className="pt-2">
          <p className="text-xs tracking-widest uppercase text-gold/50 font-body mb-3">Professional Highlights</p>
          <ul className="space-y-2">
            {partner.highlights.map((hl) =>
              <li key={hl} className="text-sm text-gray-400 font-body flex items-start gap-2">
                <span className="text-gold/60 mt-1.5 block w-1 h-1 rounded-full bg-gold/60 flex-shrink-0" />
                {hl}
              </li>
            )}
          </ul>
        </div>
      }
    </div>
  </div>
);

export default function Partners() {
  return (
    <section id="partners" data-testid="partners-section" className="py-24 md:py-32 bg-navy-base">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium mb-4">
            Our Team
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-white">
            Partners who shape outcomes.
          </h2>
          <div className="h-px w-16 bg-gold/40 mt-6" />
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {partners.map((partner, i) =>
            <PartnerCard key={partner.name} partner={partner} index={i} />
          )}
        </div>
      </div>
    </section>);

}